import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './MultiFactorTable.less';

MultiFactorTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      column1: PropTypes.string.isRequired,
      column2: PropTypes.string.isRequired,
      header: PropTypes.bool.isRequired,
    }).isRequired
  ).isRequired,
};

const cx = classnames.bind(styles);

function renderTableData(data) {
  return data.map((item, i) => (
    <tr className={item.header ? cx('header') : cx('label')} key={i}>
      <td>{item.column1}</td>
      <td>{item.column2}</td>
    </tr>
  ));
}

export default function MultiFactorTable({ data }) {
  return (
    <table className={cx('multi-factor-table')}>
      <tbody>{renderTableData(data)}</tbody>
    </table>
  );
}
